module.exports = __webpack_public_path__ + "pengdps.png?d0d7588d0666219bcf989d8407492070";